import { render } from "./SignatureCard.vue?vue&type=template&id=6527836a&scoped=true"
import script from "./SignatureCard.vue?vue&type=script&lang=js"
export * from "./SignatureCard.vue?vue&type=script&lang=js"

import "./SignatureCard.vue?vue&type=style&index=0&id=6527836a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6527836a"]])

export default __exports__